import { headerCareersConfig } from "./careers/careers-header.config";
import { careersCIEnvironmentConfig } from "./careers/careers-ci-environment.config";
import { careersApplicationFormConfig } from "./careers/careers-application-form.config";
import { careersCTAConfig } from "./careers/careers-cta.config";
import { careersFAQsConfig } from "./careers/careers-faqs.config";
import { careersDataConfig } from "./careers/careers-data.config";
import { careersAboutUsConfig } from "./careers/careers-about-us.config";
import { awardsConfig } from "./general/awards.config";
import { testimonialsProfessionalsConfig } from "./general/testimonials-professionals.config";
import { locationCTAConfig } from "./locations/location-cta.config";
import { testimonialsConfig } from "./home/testimonials.config";
import { heroConfig } from "./home/hero.config";
import { headerConfig } from "./services/header.config";
import { contactHomeConfig } from "./home/contact-home.config";
import { servicesWeOfferConfig } from "./services/services-we-offer.config";
import { buildRewardingCareerConfig } from "./home/build-rewarding-career.config";
import { faqsConfig } from "./services/faqs.config";
import { headerLocationsConfig } from "./locations/header-locations.config";
import { productDescriptionConfig } from "./services/product-description.config";
import { textCardGroupConfig } from "./services/text-card-group.config";
import { benefitsConfig } from "./services/benefits.config";
import { ctaServicesConfig } from "./services/cta-services.config";
import { twoColumnTextConfig } from "./services/two-column-text.config";
import { typesOfMedicalStaffingSolutionsConfig } from "./services/types-of-medical-staffing-solutions.config";
import { customJsonLdConfig } from "./general/custom-json-ld.config";
import { otherLocationsConfig } from "./locations/other-locations.config";
import { findALocationConfig } from "./locations/find-a-location.config";
import { officeLocationsConfig } from "./locations/office-locations.config";
import { locationsServicesConfig } from "./locations/locations-services.config";
import { awardsTestimonialsConfig } from "./locations/awards-testimonials.config";
import { formInquiryPromotionConfig } from "./forms/form-inquiry-promotion.config";
import { ciAppDemoRequestConfig } from "./forms/ci-app-demo-request-form.config";
import { ciAppDemoFormConfig } from "./forms/ci-app-demo-form.config";
import { keyFeaturesConfig } from "./ci-app/key-features.config";
import { Component } from "@builder.io/sdk";
import { heroCiAppConfig } from "./ci-app/hero-ci-app.config";
import { faqsCiAppConfig } from "./ci-app/faqs-ci-app.config";
import { footerCiAppConfig } from "./ci-app/footer-ci-app.config";

// Export all configs for easy import in the main builder-registry
export const componentConfigs: Record<string, Component> = {
  headerCareers: headerCareersConfig,
  careersCIEnvironment: careersCIEnvironmentConfig,
  careersApplicationForm: careersApplicationFormConfig,
  careersCTA: careersCTAConfig,
  careersFAQs: careersFAQsConfig,
  careersData: careersDataConfig,
  careersAboutUs: careersAboutUsConfig,
  awards: awardsConfig,
  testimonialsProfessionals: testimonialsProfessionalsConfig,
  locationCTA: locationCTAConfig,
  testimonials: testimonialsConfig,
  hero: heroConfig,
  header: headerConfig,
  contactHome: contactHomeConfig,
  servicesWeOffer: servicesWeOfferConfig,
  buildRewardingCareer: buildRewardingCareerConfig,
  faqs: faqsConfig,
  headerLocations: headerLocationsConfig,
  productDescription: productDescriptionConfig,
  textCardGroup: textCardGroupConfig,
  benefits: benefitsConfig,
  ctaServices: ctaServicesConfig,
  twoColumnText: twoColumnTextConfig,
  typesOfMedicalStaffingSolutions: typesOfMedicalStaffingSolutionsConfig,
  customJsonLd: customJsonLdConfig,
  otherLocations: otherLocationsConfig,
  findALocation: findALocationConfig,
  officeLocations: officeLocationsConfig,
  locationsServices: locationsServicesConfig,
  awardsTestimonials: awardsTestimonialsConfig,
  formInquiryPromotion: formInquiryPromotionConfig,
  ciAppDemoRequest: ciAppDemoRequestConfig,
  ciAppDemoForm: ciAppDemoFormConfig,
  keyFeatures: keyFeaturesConfig,
  heroCiApp: heroCiAppConfig,
  faqsCiApp: faqsCiAppConfig,
  footerCiApp: footerCiAppConfig,
};
